import styled from 'styled-components';
import { space, color, textAlign, fontSize, fontWeight } from 'styled-system';
import { ThemeInterface } from '../theme/ThemeInterface';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { theme } from '../theme';

type Props = StyledSystemProps & {
  pointer?: boolean;
};

const H4 = styled.h4<Props>`
  ${space};
  ${color};
  ${fontSize};
  ${textAlign};
  ${fontWeight};
  text-transform: ${(props: ThemeInterface) => props.textTransform || 'none'};
  &:hover {
    cursor: ${(props: ThemeInterface) => (props.pointer ? 'pointer' : 'default')};
  }
`;

export default H4;

H4.defaultProps = {
  m: 0,
  fontSize: 1,
  color: theme.colors.charcoalGrey,
};



// WEBPACK FOOTER //
// ./src/typography/H4.ts